import {useCallback, useRef} from 'react'

import throttle from 'lodash.throttle'

export function useThrottledFunction<T extends (...args: any[]) => any>(
  func: T,
  wait?: Parameters<typeof throttle>[1],
  options?: Parameters<typeof throttle>[2]
): (...args: Parameters<T>) => void {
  const throttledFuncRef = useRef(throttle(func, wait, options)).current

  return useCallback(throttledFuncRef, [throttledFuncRef])
}
